export default {
      id: "back-window-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#back-window",
      toString: function () {
        return this.url;
      }
    }